import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL Target Range
export const rangeList = (params = '') => Http.get(`/marketing-age-ranges${serialize(params)}`)
export const rangeCreate = (params = '') => Http.post('/marketing-age-ranges', params)
export const rangeByID = (params = '') => Http.get(`/marketing-age-ranges/${params}`)
export const rangeUpdate = (params = '') => Http.put(`/marketing-age-ranges/${params.id}`, params)
export const rangeDestroy = (params = '') => Http.delete(`/marketing-age-ranges/${params.id}`)
